import { render, staticRenderFns } from "./AsHistoryTabsItems.vue?vue&type=template&id=3dbf1c86&scoped=true"
import script from "./AsHistoryTabsItems.vue?vue&type=script&lang=js"
export * from "./AsHistoryTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf1c86",
  null
  
)

export default component.exports